<template>
  <a-table
    rowKey="index"
    :scroll="{ x: 1000 }"
    :dataSource="dataList"
    :columns="columns"
    size="small"
    :pagination="false"
    class="mb20 "
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'deal'">
        <a-button type="link" @click="() => queryDetail(record)">编辑</a-button>
      </template>
    </template>
  </a-table>
  <Pagination v-if="dataList && dataList.length > 0" />

  <EventAlert v-if="visible" />
</template>
<script>
import { toRefs, inject, computed } from 'vue'
import EventAlert from './EventAlert'
export default {
  components: {
    EventAlert
  },
  setup() {
    const state = inject('state')
    const columns = computed(() => {
      const field = state.fields
      let arr = []
      Object.keys(field).forEach(key => {
        arr.push({
          title: field[key],
          dataIndex: key,
          key: key,
          width: 100
        })
      })
      arr.push({
        title: '操作',
        key: 'deal',
        width: 100,
        fixed: 'right'
      })
      return arr
    })
    return {
      ...toRefs(state),
      columns
    }
  }
}
</script>
<style lang="scss" scoped></style>
